
import {of as observableOf } from 'rxjs';
/**
 * Created by christiancueni on 12/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { AppState } from "../reducers";
import { HelloClassApiService } from "../services/helloclass";
import { LoginAction } from "../actions/authentication";

/**
 * Guards are hooks into the route resolution process, providing an opportunity
 * to inform the router's navigation process whether the route should continue
 * to activate this route. Guards must return an observable of true or false.
 */
@Injectable()
export class AutoLoginGuard  {
    constructor(
        private store: Store<AppState>,
        private apiService: HelloClassApiService,
        private router: Router
    ) { }


    verifyParams(queryParams: Object) {
        if (!queryParams['user'] && !queryParams['password']) {
            this.router.navigate(['/login']);
            return observableOf(false);
        }

        this.store.dispatch(new LoginAction({ username: queryParams['user'], password: queryParams['password'] }));

        this.router.navigate(['/login']);
        return observableOf(true);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.verifyParams(route.queryParams);
    }
}
